
import { Edit, Launch } from '@mui/icons-material'
import { Button, Card, CardActions, CardContent, CardHeader, Divider } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function AboutCard() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    return (
        <Card >
            <CardHeader title={t("About us")} />
            <Divider />
            {/* <CardContent>
                {t("You can edit the about us page and go to the about us page to view it as a user.")}
            </CardContent>
            <Divider /> */}
            <CardActions>
                <Button
                    variant="contained"
                    color="primary"
                    sx={{ textTransform: "none" }}
                    endIcon={<Launch />}
                    onClick={() => navigate("/about")}
                >
                    {t("Open")}
                </Button>
                <Button
                    variant="contained"
                    color="success"
                    sx={{ textTransform: "none" }}
                    endIcon={<Edit />}
                    onClick={() => navigate("/admin/settings/about")}
                >
                    {t("Edit")}
                </Button>
            </CardActions>
        </Card>
    )
}
